import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectSafeUrlService {
  safeOpen(redirectUrl: string, envDomain: string, target: '_self' | '_blank' | '_parent' | '_top'): void {
    const parsedRedirectUrl = new URL(redirectUrl);
    if (
      parsedRedirectUrl.hostname.endsWith(`.${envDomain}`) ||
      // Jobs i18n urls
      parsedRedirectUrl.hostname === 'it.wizbii.com' ||
      parsedRedirectUrl.hostname === 'es.wizbii.com' ||
      parsedRedirectUrl.hostname === 'de.wizbii.com'
    ) {
      window.open(redirectUrl, target);
      return;
    }
    window.open(`https://${envDomain}`, target);
  }
}
